module.exports = __webpack_public_path__ + "static/media/pathfinder-hero.f689ad7b.jpg";